import {
    WidgetLoadRequest
} from '@amzn/ans-chat-widget-commons';
import { CommonUtils } from '../utility/commonUtils';

/**
 * This class is responsible for generating load request and handing anything specific to Delphi/AnsChatWidget.
 */
export class AnsChatWidgetUtil {
    static getWidgetLoadRequest(): WidgetLoadRequest {
        return {
            clientParams: {
                clientRequestId: CommonUtils.getRequestId(),
                clientSessionId: CommonUtils.getClientSessionId(),
            }
        }
    }
}
